import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { authFetch } from "../context/AuthContext";

const SIGN_GLYPH = {
    Aries: "♈", Taurus: "♉", Gemini: "♊", Cancer: "♋", Leo: "♌", Virgo: "♍",
    Libra: "♎", Scorpio: "♏", Sagittarius: "♐", Capricorn: "♑", Aquarius: "♒", Pisces: "♓",
};

export default function MyMatches() {
    const [matches, setMatches] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        authFetch("get", "/matches/list").then((r) => setMatches(r.data.matches)).finally(() => setLoading(false));
    }, []);

    return (
        <>
            <Navbar />
            <main className="min-h-screen pt-28 pb-12 px-6">
                <div className="max-w-4xl mx-auto">
                    <p className="label-tracking text-gold">Mutual Connections</p>
                    <h1 className="font-serif text-5xl mt-2">Your Matches</h1>

                    {loading && <p className="text-muted mt-10">Loading...</p>}

                    {!loading && matches.length === 0 && (
                        <div className="glass p-12 text-center mt-8">
                            <p className="font-serif text-2xl">No mutual matches yet</p>
                            <p className="text-muted mt-3">When two souls like each other, the stars align here.</p>
                            <Link to="/matches" className="btn-gold-solid inline-block mt-6" data-testid="goto-matches">
                                Begin Swiping
                            </Link>
                        </div>
                    )}

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
                        {matches.map((m) => (
                            <div
                                key={m.match_id}
                                className="glass hover-lift p-6"
                                data-testid={`match-${m.user.user_id}`}
                            >
                                <div className="flex items-center justify-between">
                                    <div>
                                        <h3 className="font-serif text-2xl">{m.user.name}</h3>
                                        <p className="text-sm text-muted mt-1">{m.user.birth_location}</p>
                                    </div>
                                    <div className="text-center">
                                        <p className="font-serif text-4xl text-gold">{m.compatibility.overall}</p>
                                        <p className="label-tracking text-xs">Score</p>
                                    </div>
                                </div>
                                <div className="flex gap-2 mt-4">
                                    <span className="text-xs px-3 py-1 rounded-full bg-white/5 border border-white/10">
                                        {SIGN_GLYPH[m.user.sun]} {m.user.sun}
                                    </span>
                                    <span className="text-xs px-3 py-1 rounded-full bg-white/5 border border-white/10">
                                        {SIGN_GLYPH[m.user.moon]} {m.user.moon}
                                    </span>
                                    <span className="text-xs px-3 py-1 rounded-full bg-white/5 border border-white/10">
                                        {SIGN_GLYPH[m.user.rising]} {m.user.rising}
                                    </span>
                                </div>
                                <div className="flex gap-2 mt-5">
                                    <Link
                                        to={`/messages/${m.match_id}`}
                                        className="btn-gold-solid flex-1 text-center"
                                        data-testid={`message-${m.user.user_id}`}
                                    >
                                        Message
                                    </Link>
                                    <Link
                                        to={`/compatibility/${m.user.user_id}`}
                                        className="btn-gold flex-1 text-center"
                                        data-testid={`synastry-${m.user.user_id}`}
                                    >
                                        Synastry
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        </>
    );
}
